<script setup>
    import { UserIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <UserIcon />
</template>
